import React, { useEffect } from "react";
import { Button, Dimmer, Loader } from "semantic-ui-react";

import SemanticUiModal from "../modal";
import useApiService from "../../services/useApiService";
import ControlTranslationIdLabel from "../control_translation_id_label";
import TranslationModalContent from "./translation_modal_content";

const modalOptions = { className: "tanslations-modal", size: "small" };

export default function TranslationModal(props) {
  const { translation_id, onClose } = props;
  const [{ isLoading, response: translation }] = useApiService({
    url: `/library_control_translations/${translation_id}`,
    onMount: true,
  });
  const [{ response: control }, getControl] = useApiService({ url: `/library_controls/${translation && translation.library_control_id}` });

  useEffect(() => {
    if (!translation) return;

    getControl();
  }, [translation]);

  return (
    <SemanticUiModal
      header={
        <span>
          Translation&nbsp;
          <ControlTranslationIdLabel translation={translation} />
        </span>
      }
      content={
        isLoading ? (
          <div className="position-relative">
            <Dimmer active inverted>
              <Loader inverted />
            </Dimmer>
          </div>
        ) : (
          <TranslationModalContent translation={translation} control={control || {}} />
        )
      }
      actions={
        <Button positive onClick={onClose}>
          Close
        </Button>
      }
      modalOptions={modalOptions}
      closeModal={onClose}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/translation_modal/translation_modal.js